import { TextLink } from "@abb/arcadia-ui-react"
import { StatusCodes } from "http-status-codes"
import { useCallback, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../../services/api"
import { DiMaProgress } from "../../../../components/DiMaProgress"
import { UserApproverGet } from "../../../../models/User"
import { EntityTab } from "../../../partials/EntityTab"

export function UserApproverRoles() {
  const [approverRoles, setApproverRoles] = useState<UserApproverGet[]>([])
  const [isLoadingApproverRoles, setIsLoadingApproverRoles] = useState(true)
  const navigate = useNavigate()
  const { userId } = useParams()
  const returnURL = `/users/${userId}#details`

  useEffect(() => {
    digitalManagerApi
      .get<UserApproverGet[]>(`/users/${userId}/approvers`)
      .then((res) => {
        if (res.status === StatusCodes.OK) {
          setApproverRoles(res.data)
        }
      })
      .catch(() => navigate(returnURL))
      .finally(() => setIsLoadingApproverRoles(false))
  }, [userId, returnURL, navigate])

  const cols = [
    { field: "approverType", headerName: "Approver Type" },
    { field: "application", headerName: "Application" },
    { field: "role", headerName: "Role" },
    { field: "property", headerName: "Property" },
  ]

  const handleRoleClick = useCallback(
    (applicationId: string, roleId: string) => () => {
      navigate(`/applications/${applicationId}/roles/${roleId}/approvers/${userId}`)
    },
    [navigate, userId]
  )

  if (isLoadingApproverRoles) {
    return <DiMaProgress />
  }

  const rows = approverRoles.map((r) => ({
    id: r.id,

    approverType: (
      <TextLink
        text={r.approverType}
        size={14}
        onClick={handleRoleClick(r.application.id, r.role.id)}
      />
    ),

    application: r.application.shortName,

    role: r.role.name,

    property:
      r.property.name == null ? "Generic" : `${r.property.name}: ${r.property.label}`,
  }))

  return <EntityTab rows={rows} cols={cols} isLoading={isLoadingApproverRoles} />
}
